function videoPlay(self) {
    const regex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=([a-zA-Z0-9_-]+))(.*)$/;
    let src = self.getAttribute('data-url');
    let mobileSrc = self.getAttribute('mobile-data-url');
    const mobileQuery = window.matchMedia('(max-width: 640px)');

    const handleVideoSource = (e) => {
        const videoSrc = (e.matches && mobileSrc) ? mobileSrc : src;
        if (!videoSrc) {
            throw new Error('Video source not available');
        }
        return videoSrc;
    };
    if (self.getAttribute('data-url').match(regex)) {
        src = convertToEmbedUrl(self.getAttribute('data-url'));
        self.parentNode.innerHTML = `
            <iframe src="${src}" width="100%" height="100%" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen/>
        `;
    } else if (src.length) {
        const currentSrc = handleVideoSource(mobileQuery);
        self.parentNode.innerHTML = `
            <video class="distributor-video__video-window" playsinline autoplay name="media"><source src="${currentSrc}" type="video/mp4"></video>
        `;

        mobileQuery.addEventListener('change', (e) => {
            const newSrc = handleVideoSource(e);
            const videoEl = self.parentNode.querySelector('video source');
            if (videoEl) {
                videoEl.src = newSrc;
                videoEl.parentElement.load();
            }
        });
    }
}

function convertToEmbedUrl(normalUrl) {
    // Check if the provided URL is a valid YouTube URL
    const regex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=([a-zA-Z0-9_-]+))(.*)$/;
    const match = normalUrl.match(regex);

    if (match) {
        // Extract the video ID from the URL
        const videoId = match[4];

        // Construct the embed URL
        const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0`;

        return embedUrl;
    } else {
        // If the provided URL is not a valid YouTube URL, return null or handle the error accordingly
        console.error('Invalid YouTube URL');
        return null;
    }
}

window.onload = function () {
    if (document.querySelector('.video-click-play')) {
        const videoOverlay = document.querySelectorAll('.video-click-play__overlay');

        videoOverlay.forEach(element => {
            element.addEventListener('click', function (ev) {
                ev.preventDefault();

                let __this = this;
                videoPlay(__this);
            });
        });
    }
};

function setResponsiveImages() {
    const mobileMediaQuery = window.matchMedia('(max-width: 640px)');

    function updateImages(isMobile) {
        const image = document.querySelector('.js-image-responsive');
        if (isMobile) {
            image.src = image.getAttribute('data-src-mobile');
        } else {
            image.src = image.getAttribute('data-src');
        }
    }

    function handleMediaQueryChange(mediaQuery) {
        updateImages(mediaQuery.matches);
    }

    mobileMediaQuery.addEventListener('change', handleMediaQueryChange);

    updateImages(mobileMediaQuery.matches);
}

if(document.querySelector('.js-image-responsive')) {
    window.addEventListener('load', setResponsiveImages);
}
